module.exports = __webpack_public_path__ + "static/rymel-6b6bb48f6b648c322ebc7048f8c8ba68.png";